import { MenuItem, TextField } from '@mui/material';
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { DropdownOption } from 'shared/types';

interface EditCellDropdownProps {
  data: DropdownOption[];
  params: GridRenderCellParams<string>;
}

export function EditCellDropdown({ data, params }: EditCellDropdownProps) {
  const apiRef = useGridApiContext();

  const handleSelect = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    apiRef.current.setEditCellValue({ id: params.id, field: params.field, value: event.target.value });
  };

  return (
    <TextField
      id={`${params.field}-dropdown-${params.id}`}
      value={params.value}
      fullWidth={true}
      select
      onChange={handleSelect}
    >
      {data.map(option => (
        <MenuItem key={option.uniqueId} value={option.value}>
          {option.value}
        </MenuItem>
      ))}
    </TextField>
  );
}
